'use client';
import SideMenuIcon from '~public/assets/icons/side-menu.svg';
import { useHeaderContext } from '~widgets/Header/context';

import { StyledSideMenuButton } from './styles';

export const SideMenuButton = () => {
	const { headerRef, toggleSideMenu, setHeaderOffset } = useHeaderContext();

	return (
		<StyledSideMenuButton
			onClick={() => {
				if (headerRef.current) {
					setHeaderOffset(headerRef.current.getBoundingClientRect().top);
				}
				toggleSideMenu();
			}}
			size="M"
			leftIcon={<SideMenuIcon />}
		/>
	);
};
